<eaglei-leaflet-layer-header [layer]="this" (activeToggled)="toggleLayer($event)" [hideLegend]="true"></eaglei-leaflet-layer-header>

<ng-container *ngIf="isActive">
    <div #legendElement>
        <div class="dot-legend">
            <div class="circle river" style="background-color: #ca7bf5"></div>
            <p>River</p>
        </div>

        <div class="dot-legend">
            <div class="circle sector" style="background-color: #388cff"></div>
            <p>Sector</p>
        </div>
    </div>
</ng-container>
